<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-on:click="onClickPreview()" v-bind:class="getDisableClass">
        {{ $t('Preview') }}
    </button>    
</div>

